import { FC } from "react";
import BottomKPIBar, {
  KPI
} from "@/components/controls/BottomKPIBar/BottomKPIBar";
import { ServicesAggregations } from "@/entities/services/hooks";

interface ServicesKPIData extends Record<string, number> {
  total: number;
  totalValue: number;
}

const kpis: KPI<ServicesKPIData>[] = [
  { name: "total" },
  { name: "totalValue", isMonetary: true }
];

interface Props {
  aggregations: ServicesAggregations;
  isLoading?: boolean;
  isError?: boolean;
}

const ServicesBottomKPIBar: FC<Props> = ({
  aggregations,
  isLoading,
  isError
}) => {
  const data: ServicesKPIData = {
    total: aggregations.totalCount,
    totalValue: aggregations.totalValue
  };

  return (
    <BottomKPIBar<ServicesKPIData>
      kpis={kpis}
      data={data}
      pageName="services"
      isLoading={isLoading}
      isError={isError}
    />
  );
};

export default ServicesBottomKPIBar;
